module.exports = __webpack_public_path__ + "img/logo1.27c9487e.png";